import classes from "./FlightBookingGuide.module.css";

export function ReadingProgress({ step = 0, milestones }) {
  if (!milestones || milestones.length === 0) return null;

  const getClassName = (step, i) => {
    if (step === i || (step < 0 && i === 0)) return classes.current;
    if (step > i) return classes.past;
    return "";
  };

  return (
    <nav className={classes.readingProgress}>
      <ul className={classes.milestones}>
        {milestones.map((milestone, i) => (
          <li key={i} className={getClassName(step, i)}>
            <a
              href={`#${milestone.anchor}`}
              className={classes.link}
              aria-label={`Jump to section: ${milestone.title}`}
              title={milestone.title}>
              <h4 className={classes.heading}>{milestone.title}</h4>
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
